"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.processPostMessage = exports.isValidMessage = exports.getV2Message = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

var isValidMessage = function isValidMessage(data) {
  return typeof data === 'string' && data.indexOf('m$m') === 0 || Boolean(data) && _typeof(data) === 'object' && data.hasOwnProperty('method');
};

exports.isValidMessage = isValidMessage;

var getV2Message = function getV2Message(data) {
  if (typeof data !== 'string') {
    return _objectSpread(_objectSpread({}, data), {
      version: 2
    });
  }

  try {
    return _objectSpread(_objectSpread({}, JSON.parse(data)), {
      version: 2
    });
  } catch (error) {
    return null;
  }
};

exports.getV2Message = getV2Message;

var processPostMessage = function processPostMessage(_ref) {
  var data = _ref.data;

  // Framework 1 message
  if (typeof data === 'string' && data.indexOf('m$m') === 0) {
    var parts = data.split('@@');
    var paramParts = parts[2].split(':');
    var param = {};
    param[paramParts[0]] = paramParts[1];
    return _objectSpread(_objectSpread({}, {
      version: 1,
      method: parts[1],
      pillUrl: parts[3]
    }), param);
  }

  var frameworkV2Message = getV2Message(data);
  return isValidMessage(frameworkV2Message) ? frameworkV2Message : null;
};

exports.processPostMessage = processPostMessage;